import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Route, Switch } from "react-router-dom";

import "components/ReduxSpinner/nprogress.css";

import AppAppBar from "public/LandingPage/modules/views/AppAppBar";
import ProductHeroLayout from "public/LandingPage/modules/views/ProductHeroLayout";
import { ForgetPassword } from "public/ForgetPassword";
import { ResetPassword } from "public/ResetPassword";
import { PageNotFound } from "components/PageNotFound";
import { SignUp } from "public/SignUp";
import { routing } from "routing";

const { Urls } = routing;

const useStyles = makeStyles(() => ({
  background: {
    backgroundImage: `url(${backgroundImage})`,
    backgroundColor: "#7fc7d9", // Average color of the background image.
    backgroundPosition: "center",
  },
}));

const backgroundImage = "/statistics-bk.jpg";

export const LandscapePage = () => {
  const classes = useStyles();

  return (
    <>
      <AppAppBar />
      <ProductHeroLayout backgroundClassName={classes.background}>
        <img style={{ display: "none" }} src={backgroundImage} alt="" />
        <Switch>
          <Route
            exact
            path={`${Urls.FORGOT_PASSWORD}`}
            component={ForgetPassword}
          />
          <Route
            exact
            path={`${Urls.RESET_PASSWORD_URL_PATTERN}`}
            component={ResetPassword}
          />
          <Route exact path={`${Urls.SIGN_UP}`} component={SignUp} />
          <Route exact path={`${Urls.NOT_FOUND}`} component={PageNotFound} />
        </Switch>
      </ProductHeroLayout>
    </>
  );
};
